import { combineReducers } from 'redux';

import profesor from './profesor';

const rootReducer = combineReducers({
	profesor
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/ducks/rootReducer.js